import React, { useState } from 'react';

function Settings({ user, onBack }) {
  const [notifications, setNotifications] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
  const [language, setLanguage] = useState('English');
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  const Toggle = ({ value, onChange }) => (
    <button onClick={() => onChange(!value)}
      className={`w-12 h-6 rounded-full transition-all relative ${value ? 'bg-[#0B3C95]' : 'bg-gray-200'}`}>
      <div className={`w-5 h-5 bg-white rounded-full absolute top-0.5 transition-all shadow-sm ${value ? 'right-0.5' : 'left-0.5'}`} />
    </button>
  );

  return (
    <div className="min-h-screen bg-[#F4F7FC]" style={{ fontFamily: 'Inter, sans-serif' }}>
      <div className="bg-white px-4 py-4 flex items-center gap-3 border-b border-gray-100 shadow-sm">
        <button onClick={onBack} className="w-9 h-9 flex items-center justify-center text-gray-500 hover:bg-gray-100 rounded-full">
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
        <h1 className="font-black text-[#0D1B2A] text-lg">Settings</h1>
      </div>

      <div className="px-4 py-5 space-y-4">
        {saved && <div className="p-3 bg-green-50 text-green-700 border border-green-200 rounded-xl text-sm font-semibold">✅ Settings saved!</div>}

        {/* Notifications */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Notifications</p>
          <div className="flex items-center justify-between py-2">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-[#0B3C95]/10 rounded-xl flex items-center justify-center">
                <span className="material-symbols-outlined text-[#0B3C95]" style={{ fontSize: '18px' }}>notifications</span>
              </div>
              <div>
                <p className="text-sm font-bold text-[#0D1B2A]">Push Notifications</p>
                <p className="text-xs text-gray-400">Medication & report alerts</p>
              </div>
            </div>
            <Toggle value={notifications} onChange={setNotifications} />
          </div>
        </div>

        {/* Appearance */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Appearance</p>
          <div className="flex items-center justify-between py-2">
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 bg-gray-100 rounded-xl flex items-center justify-center">
                <span className="material-symbols-outlined text-gray-600" style={{ fontSize: '18px' }}>dark_mode</span>
              </div>
              <div>
                <p className="text-sm font-bold text-[#0D1B2A]">Dark Mode</p>
                <p className="text-xs text-gray-400">Coming soon</p>
              </div>
            </div>
            <Toggle value={darkMode} onChange={setDarkMode} />
          </div>
        </div>

        {/* Language */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Language</p>
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-[#0B3C95]/10 rounded-xl flex items-center justify-center">
              <span className="material-symbols-outlined text-[#0B3C95]" style={{ fontSize: '18px' }}>language</span>
            </div>
            <select value={language} onChange={e => setLanguage(e.target.value)}
              className="flex-1 px-3 py-2.5 border border-gray-200 rounded-xl text-sm bg-[#f8f9fb] focus:outline-none focus:border-[#0B3C95]">
              <option>English</option>
              <option>Hindi</option>
              <option>Telugu</option>
              <option>Tamil</option>
            </select>
          </div>
        </div>

        {/* Account */}
        <div className="bg-white rounded-2xl border border-gray-100 shadow-sm p-4">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">Account</p>
          {[
            { icon: 'lock', label: 'Change Password', color: '#0B3C95' },
            { icon: 'download', label: 'Download My Data', color: '#00A884' },
            { icon: 'delete_forever', label: 'Delete Account', color: '#EF4444' },
          ].map(item => (
            <button key={item.label} className="w-full flex items-center justify-between py-3 border-b border-gray-50 last:border-0">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${item.color}15` }}>
                  <span className="material-symbols-outlined" style={{ fontSize: '18px', color: item.color }}>{item.icon}</span>
                </div>
                <p className="text-sm font-semibold" style={{ color: item.color === '#EF4444' ? '#EF4444' : '#0D1B2A' }}>{item.label}</p>
              </div>
              <span className="material-symbols-outlined text-gray-300" style={{ fontSize: '18px' }}>chevron_right</span>
            </button>
          ))}
        </div>

        <button onClick={handleSave}
          className="w-full py-4 bg-[#0B3C95] text-white font-bold rounded-2xl text-sm active:scale-95 transition-all"
          style={{ boxShadow: '0 8px 25px rgba(11,60,149,0.3)' }}>
          Save Settings
        </button>

        <p className="text-center text-gray-300 text-xs pb-4">MyHealth Journal v1.0.0 • 🇮🇳 Made in India</p>
      </div>
    </div>
  );
}

export default Settings;